
import { defineComponent, ref, reactive, inject, onMounted } from "vue";
import { targetList, addWolfTarget, delTarget, getOrderCarSelectList } from "@/api/shenghuiHttp";
import { ElMessageBox, ElMessage } from "element-plus";

export default defineComponent({
    name: "Performance",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["业绩目标"]);

        const headClass = inject("headClass");
        const loading = ref(false);
        const tableData = ref([] as any[]);
        const total = ref(0);
        const pageSize = ref(10);
        const currentPage = ref(1);
        const insuranceList = ref([] as any[]);
        const dialogVisible = ref(false);

        const screenParams = reactive({ b_id: "" as any });
        const editForm = reactive({ id: null as any, b_id: "", month: "", money: "" });

        const formatMoney = (val: any): string => val ? Number(val).toLocaleString() : '0';

        const getTableData = (): void => {
            loading.value = true;
            const data: any = {
                page: currentPage.value,
                pagesize: pageSize.value,
            };
            if (screenParams.b_id) data.b_id = screenParams.b_id;
            targetList(data).then((res: any) => {
                tableData.value = res?.content?.list || [];
                total.value = res?.content?.count || 0;
                loading.value = false;
            }).catch(() => { loading.value = false; });
        };

        const handleSizeChange = (size: number) => { pageSize.value = size; currentPage.value = 1; getTableData(); };
        const handleCurrentChange = (page: number) => { currentPage.value = page; getTableData(); };

        const openDialog = (row: any) => {
            if (row) {
                editForm.id = row.id;
                editForm.b_id = row.b_id;
                editForm.month = row.month;
                editForm.money = row.money;
            } else {
                editForm.id = null;
                editForm.b_id = "";
                editForm.month = "";
                editForm.money = "";
            }
            dialogVisible.value = true;
        };

        const submitForm = () => {
            if (!editForm.b_id) { ElMessage.warning("请选择保险公司"); return; }
            if (!editForm.month) { ElMessage.warning("请选择月份"); return; }
            if (!editForm.money) { ElMessage.warning("请输入目标金额"); return; }
            const d = new Date(editForm.month as any);
            const monthStr = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
            addWolfTarget({ ...editForm, month: monthStr }).then((res: any) => {
                if (res.status === 202) {
                    dialogVisible.value = false;
                    getTableData();
                }
            });
        };

        const delRow = (row: any) => {
            ElMessageBox.confirm("确定删除该业绩目标？", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" })
                .then(() => {
                    delTarget({ id: row.id }).then((res: any) => {
                        if (res.status === 202) {
                            getTableData();
                        }
                    });
                }).catch(() => { });
        };

        onMounted(() => {
            getOrderCarSelectList().then((res: any) => {
                insuranceList.value = res?.content?.insurance_data || [];
            });
            getTableData();
        });

        return {
            headClass, loading, tableData, total, pageSize, currentPage,
            insuranceList, screenParams, editForm, dialogVisible,
            formatMoney, getTableData, handleSizeChange, handleCurrentChange,
            openDialog, submitForm, delRow,
        };
    },
});
